import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SeatData } from '../../Redux/action/seatAction';
import { CSVLink } from 'react-csv';

import { dataUser, logoutHandler } from '../Helpers/util';
import axios from 'axios';
import AntDDropdown from '../Common/AntDDropdown/AntDDropdown';
import SwIconButton from '../Common/SwIconButton/SwIconButton';

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
var exportData = [];
// var totalCount;
class ShotBySeat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      company_id: UserObj.company_id,
      status: 'all',
      order: '',
      loadingExport: {
        key: 'export-loading',
        icon: <i className="bi bi-upload" />,
        label: 'Loading Export Seats...',
        disabled: true,
      },
      userRole: UserObj && UserObj.role_data ? UserObj.role_data : [],
    };
  }

  refreshPage = () => {
    this.props.page(1);
    this.props.page(25);
    let param = {
      pgno: 1,
      row: 25,
      status: 'all',
      company_id: this.state.company_id,
    };
    if (!UserObj?.company_id) {
      logoutHandler()
    }
    this.props.SeatData(param);
  };

  componentWillReceiveProps(props) {
    this.getAllExportData(props.seatReducer?.data?.total);
  }

  setSelectsort = (sortKey) => {
    let param = {
      pgno: this.props.spage,
      row: this.props.srow,
      order: sortKey,
      company_id: this.state.company_id,
    };
    if (!UserObj?.company_id) {
      logoutHandler()
    }
    this.props.SeatData(param);
    this.props.changeshort(sortKey);
  };

  getAllExportData(totalCount) {
    if (!UserObj?.company_id) {
      logoutHandler()
    }
    let authToken = JSON.parse(localStorage.getItem('headData'))
    axios
      .post(
        `${process.env.REACT_APP_API_URL}user/flexiSeatListLight`,
        {
          pgno: 1,
          row: totalCount,
          company_id: this.state.company_id,
        },
        {
          headers: {

            Authorization: authToken?.spintlyToken,

          }
        }
      )
      .then(response => {
        exportData = response.data.data.data.list;
        const headers = [
          { label: 'Seat No', key: 'seatNo' },
          { label: 'Seat Type', key: 'seatType' },
          { label: 'Employee Name', key: 'empName' },
          { label: 'Floor', key: 'floor' },
          { label: 'Location ', key: 'location' },
          { label: 'Seat Status', key: 'seatStatus' },
          { label: 'Seat Visibility', key: 'seat_vis' },
          { label: 'Booking Start Time', key: 'startTime' },
          { label: 'Booking End Time', key: 'endTime' },
        ];
        var arr2 = exportData.map(v => ({
          seatNo: v.title,
          seatType: v.seat_type == '1' ? 'Fixed' : 'Flexi',
          empName: v.ufname + ' ' + v.ulname,
          floor: v.floor_name,
          location: v.location_name,
          seatStatus: v.status == '0' ? 'Vacant' : 'Occupied',
          seat_vis: v.seat_vis == '1' ? 'Active' : 'Inactive',
          startTime: v.seat_start_time,
          endTime: v.seat_end_time,
        }));

        this.setState({
          loadingExport: {
            key: 'export',
            icon: <i className="bi bi-upload" />,
            label: (
              <CSVLink
                data={arr2}
                headers={headers}
                filename={'Seats.csv'}
                style={{ color: 'inherit', textDecoration: 'none' }}
              >
                Export Seats
              </CSVLink>
            ),
          },
        });
      });
  }

  render() {
    const SeatManagement = this.state.userRole.find(
      element => element.service_id == '2',
    );

    return (
      <AntDDropdown
        menu={{
          onClick: ({ key }) => {
            if (['city', 'floor', 'seat'].includes(key)) {
              this.setSelectsort(key);
            }
            if (key === 'refresh') {
              this.refreshPage();
            }
          },
          items: [
            {
              key: 'sort',
              label: 'Sort by',
              icon: <i className="bi bi-sort-down-alt" />,
              children: [
                {
                  key: 'city',
                  label: 'City',
                  className: 'SortingMenu',
                },
                {
                  key: 'floor',
                  label: 'Floor',
                  className: 'SortingMenu',
                },
                {
                  key: 'seat',
                  label: 'Seat Type',
                  className: 'SortingMenu',
                },
              ],
            },
            ...(SeatManagement && SeatManagement.role_for_write === '1'
              ? [this.state.loadingExport]
              : []),
            {
              key: 'refresh',
              icon: <i className="bi bi-arrow-clockwise" />,
              label: 'Refresh List',
            },
          ],
        }}
        trigger={['click']}
        placement="bottomRight"
      >
        <SwIconButton size="sm">
          <i className="bi bi-list" />
        </SwIconButton>
      </AntDDropdown>
    );
  }
}

const mapStateToProps = state => ({
  seatReducer: state.seatReducer.SeatList,
});

const mapActionsToProps = {
  SeatData,
};

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(ShotBySeat);
